import { loadSubscription } from 'controllers/SubscriptionController';
import { store } from 'reducers/store';
export const mapDBToModelSentence = sentences => {
  return sentences.map(sentence => {
    let mappedSentence = {};
    mappedSentence['sentence'] = sentence.sentence;
    mappedSentence['rules'] = sentence.rule.map(rule => {
      return rule.rule;
    });
    mappedSentence['translation'] = sentence.translation;
    return mappedSentence;
  });
};
export const subCheck = async deprecated => {
  let storeState = await store.getState();
  if (storeState.profile) {
    const subscription = await loadSubscription(storeState.profile.username);
    if (subscription) {
      return 'granted';
    } else {
      return 'payment';
    }
  } else {
    return 'login';
  }
};